import React, { FC, useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from '@mui/material';
import DoDisturbAltIcon from '@mui/icons-material/DoDisturbAlt';
import { grey, red } from '@mui/material/colors';
import DialogContentText from '@mui/material/DialogContentText';
import ReviewService from '../../services/ReviewService';

interface Props {
  id: string | number;
  deletion: boolean;
}

const DeleteReview: FC<Props> = ({ id, deletion }) => {
  const [deleteRequestOpen, setDeleteRequestOpen] = useState<boolean>(false);
  const [deletionConfirmed, setDeletionConfirmed] = useState<boolean>(false);

  const handleClickDeleteRequestOpen = () => {
    if (!deletionConfirmed) {
      setDeleteRequestOpen(true);
    }
  };

  const handleDialogClose = () => {
    setDeleteRequestOpen(false);
  };

  const handleSubmitDelete = async () => {
    try {
      await ReviewService.saveDeletion(id, true);
      setDeletionConfirmed(true);
      setDeleteRequestOpen(false);
    } catch (error) {
      console.error('Fehler beim Löschen:', error);
    }
  };

  useEffect(() => {
    setDeletionConfirmed(deletion);
  }, [deletion]);

  return (
    <div>
      {!deletionConfirmed ? (
        <Tooltip
          title={'Löschantrag stellen'}
          arrow
        >
          <IconButton
            size="small"
            onClick={handleClickDeleteRequestOpen}
          >
            <DoDisturbAltIcon sx={{ color: grey[500] }} />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip
          title={'Löschantrag gestellt'}
          arrow
        >
          <IconButton
            size="small"
            onClick={handleClickDeleteRequestOpen}
          >
            <DoDisturbAltIcon sx={{ color: red[500] }} />
          </IconButton>
        </Tooltip>
      )}
      <Dialog
        open={deleteRequestOpen}
        onClose={handleDialogClose}
        sx={{
          '& .MuiDialog-paper': {
            width: '100%',
            maxWidth: 500,
            maxHeight: '20%',
            height: '20%',
            margin: 0,
            borderRadius: 0,
          },
          '& .MuiDialog-paperScrollPaper': {
            maxHeight: '100%',
          },
        }}
      >
        <DialogTitle>Löschantrag stellen</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Sind Sie sicher das ein Löschantrag gestellt werden soll ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Abbrechen</Button>
          <Button
            sx={{ color: red[500] }}
            onClick={handleSubmitDelete}
          >
            Bestätigen
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteReview;
